import { Typography } from '@material-ui/core';
import { formatDate } from '@superdispatch/dates';
import { Inline, Stack } from '@superdispatch/ui';
import { Box, Button } from '@superdispatch/ui-lab';
import { isWebView } from 'shared/constants/AppTypeConstants';
import { InstantTransferPriceInformation } from 'shared/modules/superpay/instant-transfer/InstantTransferPriceInformation';
import { SuperPayInstantTransferConfirmDTO } from 'shared/modules/superpay/SuperPayDTO';
import styled from 'styled-components';

const CongratulationIcon = styled(Box)`
  &:before {
    content: '🎉';
    font-size: 25px;
    position: relative;
    top: -3px;
  }
`;

const BoxStyled = styled(Box)`
  flex-direction: column;
  gap: 24px;
`;

export function InstantTransferSuccess({
  onClose,
  dialogConfirmInformation,
}: {
  onClose: () => void;
  dialogConfirmInformation: SuperPayInstantTransferConfirmDTO;
}) {
  const { load_id, sent_date, bank_account } = dialogConfirmInformation;

  return (
    <BoxStyled
      padding="medium"
      height="100%"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-end"
    >
      <Stack space="medium">
        <Box padding="medium" backgroundColor="Green50">
          <Stack space="medium">
            <Box color="Green300">
              <Stack space="xxsmall">
                <Inline verticalAlign="center" space="xxsmall">
                  <Typography variant="h2">Success</Typography>
                  <CongratulationIcon />
                </Inline>
                <Typography>
                  Your payment has been instantly transferred to your account.
                </Typography>
              </Stack>
            </Box>
            {sent_date && (
              <Stack space="xxsmall">
                <Typography color="textSecondary">Date Sent</Typography>
                <Typography>
                  {formatDate(sent_date, { variant: 'DateTime', fallback: '' })}
                </Typography>
              </Stack>
            )}
            <Stack space="xxsmall">
              <Typography color="textSecondary">Account</Typography>
              <Typography>{bank_account}</Typography>
            </Stack>
            <Stack space="xxsmall">
              <Typography color="textSecondary">Load ID</Typography>
              <Typography>{load_id}</Typography>
            </Stack>
          </Stack>
        </Box>
        <InstantTransferPriceInformation data={dialogConfirmInformation} />
      </Stack>
      <Button fullWidth={isWebView} onClick={onClose}>
        Got It
      </Button>
    </BoxStyled>
  );
}
